import { render, staticRenderFns } from "./GroupSessionCard.vue?vue&type=template&id=b00399ca&scoped=true&"
import script from "./GroupSessionCard.vue?vue&type=script&lang=js&"
export * from "./GroupSessionCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupSessionCard.vue?vue&type=style&index=0&id=b00399ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00399ca",
  null
  
)

export default component.exports